import styled from 'styled-components';
import { colorPickerTheme } from '@cld/color-picker';

export const ColorPaletteContainer = styled.div`
  margin-left: -${colorPickerTheme.palette.itemSpacing};

  li {
    margin: 0.3333rem;

    [value] {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
`;
